/**
 * /adatkezelesi-tajekoztato — GDPR Adatkezelési tájékoztató (public).
 * Hatályos: 2026. június 15-től.
 */
import React from "react";
import LegalLayout, {
  LegalContainer, LegalH1, LegalH2, LegalP, LegalUL, LegalLI, LegalStrong, LegalHR,
} from "../components/LegalLayout";

const MAIL = "tamas.mozes@successlab.com";
const NAIH_MAIL = "ugyfelszolgalat@naih.hu";

export default function LegalAdatkezelesi() {
  return (
    <LegalLayout>
      <LegalContainer testid="gdpr-page">
        <LegalH1 testid="gdpr-title">Adatkezelési tájékoztató</LegalH1>
        <LegalP><LegalStrong>Hatályos: 2026. június 15-től</LegalStrong></LegalP>
        <LegalP><LegalStrong>Weboldal:</LegalStrong> mexmagic.hu</LegalP>
        <LegalP><LegalStrong>Adatkezelés tárgya:</LegalStrong> MEX Magic weboldal, webinár regisztráció, e-mail kommunikáció, kapcsolódó marketingkommunikáció</LegalP>

        <LegalHR />
        <LegalH2>1. Az adatkezelési tájékoztató célja</LegalH2>
        <LegalP>Jelen Adatkezelési tájékoztató célja, hogy a mexmagic.hu weboldal látogatói, a webinárra regisztráló személyek és a MEX Magic kommunikációra feliratkozó felhasználók világos tájékoztatást kapjanak arról, hogy a Szolgáltató milyen személyes adatokat kezel, milyen célból, milyen jogalapon, mennyi ideig, valamint milyen jogok illetik meg őket az adatkezeléssel kapcsolatban.</LegalP>
        <LegalP>A Szolgáltató a személyes adatokat bizalmasan, a hatályos jogszabályoknak megfelelően kezeli, különösen az Európai Unió Általános Adatvédelmi Rendelete, vagyis a GDPR, valamint a magyar adatvédelmi jogszabályok alapján.</LegalP>

        <LegalHR />
        <LegalH2>2. Az adatkezelő adatai</LegalH2>
        <LegalP>Az adatkezelő: <LegalStrong>SuccessLab Kft.</LegalStrong></LegalP>
        <LegalUL>
          <LegalLI>Székhely: 1025 Budapest, Battai út 8., II/1.</LegalLI>
          <LegalLI>Képviselő: <LegalStrong>Dr. Mózes Tamás</LegalStrong></LegalLI>
          <LegalLI>E-mail: <a href={`mailto:${MAIL}`} className="text-[#5e50f7] hover:underline">{MAIL}</a></LegalLI>
          <LegalLI>Telefon: +36 20 317 1767</LegalLI>
        </LegalUL>
        <LegalP>A szolgáltatások egy részében adatkezelőként vagy közreműködőként megjelenhet: <LegalStrong>Dr. Mózes Tamás EV</LegalStrong></LegalP>
        <LegalUL>
          <LegalLI>Székhely: 1025 Budapest, Battai út 8., II/3.</LegalLI>
          <LegalLI>E-mail: <a href={`mailto:${MAIL}`} className="text-[#5e50f7] hover:underline">{MAIL}</a></LegalLI>
          <LegalLI>Telefon: +36 20 317 1767</LegalLI>
        </LegalUL>
        <LegalP>Adatvédelmi megkeresések e-mailben: <a href={`mailto:${MAIL}`} className="text-[#5e50f7] hover:underline">{MAIL}</a></LegalP>
        <LegalP>Postai cím: 1025 Budapest, Battai út 8.</LegalP>

        <LegalHR />
        <LegalH2>3. Az adatkezelés főbb céljai</LegalH2>
        <LegalP>A Szolgáltató az alábbi célokból kezelhet személyes adatokat:</LegalP>
        <LegalUL>
          <LegalLI>webinár regisztráció kezelése,</LegalLI>
          <LegalLI>webinárhoz kapcsolódó visszaigazoló és emlékeztető e-mailek küldése,</LegalLI>
          <LegalLI>MEX Magic tartalmakhoz, mesterkurzusokhoz és ajánlatokhoz kapcsolódó e-mail kommunikáció küldése,</LegalLI>
          <LegalLI>felhasználói megkeresések megválaszolása,</LegalLI>
          <LegalLI>technikai működés, biztonság és visszaélések megelőzése,</LegalLI>
          <LegalLI>marketingkampányok eredményességének mérése,</LegalLI>
          <LegalLI>jogi kötelezettségek teljesítése.</LegalLI>
        </LegalUL>

        <LegalHR />
        <LegalH2>4. Webinár regisztráció során kezelt adatok</LegalH2>
        <LegalP>A mexmagic.hu weboldalon elérhető webinárra történő regisztráció során a Szolgáltató az alábbi adatokat kezelheti:</LegalP>
        <LegalUL>
          <LegalLI>keresztnév,</LegalLI>
          <LegalLI>e-mail cím,</LegalLI>
          <LegalLI>telefonszám, ha a felhasználó opcionálisan megadja,</LegalLI>
          <LegalLI>hozzájárulás ténye és időpontja,</LegalLI>
          <LegalLI>regisztráció időpontja,</LegalLI>
          <LegalLI>forrásoldal,</LegalLI>
          <LegalLI>UTM paraméterek, ha a látogató kampánylinkről érkezik,</LegalLI>
          <LegalLI>technikai adatok, például IP-cím, böngésző és eszközinformáció, amennyiben ezek a rendszer működéséhez vagy biztonságához szükségesek.</LegalLI>
        </LegalUL>
        <LegalP>A telefonszám megadása opcionális. A felhasználó a webinárra telefonszám megadása nélkül is regisztrálhat, ha a kötelező mezőket kitölti.</LegalP>

        <LegalHR />
        <LegalH2>5. Az adatkezelés célja webinár regisztráció esetén</LegalH2>
        <LegalUL>
          <LegalLI>a regisztráció rögzítése,</LegalLI>
          <LegalLI>a webinár részleteinek elküldése,</LegalLI>
          <LegalLI>emlékeztetők és kapcsolódó információk küldése,</LegalLI>
          <LegalLI>a résztvevő azonosítása,</LegalLI>
          <LegalLI>a webinárhoz kapcsolódó kommunikáció biztosítása,</LegalLI>
          <LegalLI>a felhasználó hozzájárulása esetén további MEX Magic tartalmak és ajánlatok küldése.</LegalLI>
        </LegalUL>

        <LegalHR />
        <LegalH2>6. Az adatkezelés jogalapja</LegalH2>
        <LegalP>A webinár regisztrációhoz szükséges adatok kezelése a felhasználó kérésére történő szolgáltatásnyújtáshoz, illetve a regisztráció teljesítéséhez szükséges.</LegalP>
        <LegalP>A kapcsolódó e-mail kommunikáció, hírlevél és marketingcélú üzenetek küldése a felhasználó önkéntes hozzájárulásán alapul. A hozzájárulás bármikor visszavonható az e-mailekben található leiratkozási linken keresztül vagy az adatkezelőnek küldött e-mailben. A hozzájárulás visszavonása nem érinti a visszavonás előtti adatkezelés jogszerűségét.</LegalP>

        <LegalHR />
        <LegalH2>7. Hírlevél és MEX Magic kommunikáció</LegalH2>
        <LegalP>Amennyiben a felhasználó ehhez hozzájárul, a Szolgáltató e-mailben küldhet számára:</LegalP>
        <LegalUL>
          <LegalLI>webinár emlékeztetőket,</LegalLI>
          <LegalLI>MEX Magic tartalmakat,</LegalLI>
          <LegalLI>oktatási anyagokat,</LegalLI>
          <LegalLI>marketinggel, ügyfélszerzéssel és AI-alapú tartalomkészítéssel kapcsolatos információkat, ajánlatokat,</LegalLI>
          <LegalLI>meghívókat mesterkurzusokra, programokra és eseményekre.</LegalLI>
        </LegalUL>
        <LegalP>A felhasználó bármikor leiratkozhat az e-mailes kommunikációról.</LegalP>

        <LegalHR />
        <LegalH2>8. Adatfeldolgozók és külső szolgáltatók</LegalH2>
        <LegalP>A Szolgáltató a személyes adatok kezeléséhez külső szolgáltatókat vehet igénybe. A webinár regisztráció és e-mail kommunikáció kezeléséhez a Szolgáltató a <LegalStrong>Kit</LegalStrong> szolgáltatást használhatja. A Kit feladata lehet: feliratkozók kezelése, e-mail címek tárolása, címkék kezelése, automatikus e-mailek és emlékeztetők küldése, leiratkozások kezelése.</LegalP>
        <LegalP>A weboldal technikai működéséhez további tárhelyszolgáltató, domain szolgáltató, analitikai vagy biztonsági szolgáltató is kapcsolódhat.</LegalP>

        <LegalHR />
        <LegalH2>9. Címkék és szegmentálás</LegalH2>
        <LegalP>A webinárra regisztráló felhasználó a Kit rendszerben címkét kaphat, például: <LegalStrong>webinar-ai</LegalStrong>. Ez segít abban, hogy a Szolgáltató a regisztráló számára releváns webinárhoz kapcsolódó információkat, emlékeztetőket és tartalmakat küldjön.</LegalP>

        <LegalHR />
        <LegalH2>10. UTM paraméterek és kampánymérés</LegalH2>
        <LegalP>Amennyiben a felhasználó hirdetésből, e-mailből vagy kampánylinkről érkezik a mexmagic.hu weboldalra, a rendszer kezelheti az URL-ben szereplő UTM paramétereket. Ilyen adatok lehetnek: utm_source, utm_medium, utm_campaign, utm_content, utm_term. Ezek célja a marketingkampányok eredményességének mérése és a regisztrációk forrásának megértése.</LegalP>

        <LegalHR />
        <LegalH2>11. Az adatkezelés időtartama</LegalH2>
        <LegalP>A webinár regisztrációhoz kapcsolódó adatokat a Szolgáltató addig kezeli, amíg az a webinár lebonyolításához, az utókommunikációhoz, a felhasználói hozzájárulás alapján küldött e-mail kommunikációhoz vagy jogi kötelezettség teljesítéséhez szükséges.</LegalP>
        <LegalP>A hírlevélhez és marketingkommunikációhoz kapcsolódó adatokat a Szolgáltató a hozzájárulás visszavonásáig kezeli. A felhasználó bármikor kérheti adatai törlését vagy a kommunikáció megszüntetését.</LegalP>

        <LegalHR />
        <LegalH2>12. Adatbiztonság</LegalH2>
        <LegalP>A Szolgáltató megfelelő technikai és szervezési intézkedéseket alkalmaz a személyes adatok védelme érdekében. A Szolgáltató törekszik arra, hogy a személyes adatokhoz csak azok férjenek hozzá, akiknek erre a szolgáltatás nyújtása, technikai működtetés vagy jogi kötelezettség teljesítése miatt szükségük van.</LegalP>

        <LegalHR />
        <LegalH2>13. Az érintettek jogai</LegalH2>
        <LegalP>A felhasználó jogosult:</LegalP>
        <LegalUL>
          <LegalLI>tájékoztatást kérni a róla kezelt személyes adatokról,</LegalLI>
          <LegalLI>hozzáférést kérni az adataihoz,</LegalLI>
          <LegalLI>kérni pontatlan adatainak helyesbítését,</LegalLI>
          <LegalLI>kérni adatainak törlését,</LegalLI>
          <LegalLI>kérni az adatkezelés korlátozását,</LegalLI>
          <LegalLI>tiltakozni bizonyos adatkezelések ellen,</LegalLI>
          <LegalLI>hozzájárulását bármikor visszavonni,</LegalLI>
          <LegalLI>panaszt tenni a felügyeleti hatóságnál.</LegalLI>
        </LegalUL>
        <LegalP>Adatkezeléssel kapcsolatos kérelmeket az alábbi e-mail címen lehet benyújtani: <a href={`mailto:${MAIL}`} className="text-[#5e50f7] hover:underline">{MAIL}</a></LegalP>
        <LegalP>A Szolgáltató a kérelmeket a jogszabályban meghatározott határidőn belül válaszolja meg.</LegalP>

        <LegalHR />
        <LegalH2>14. Jogorvoslati lehetőségek</LegalH2>
        <LegalP>A felhasználó adatvédelmi kérdés vagy panasz esetén elsőként a Szolgáltatóhoz fordulhat. E-mail: <a href={`mailto:${MAIL}`} className="text-[#5e50f7] hover:underline">{MAIL}</a></LegalP>
        <LegalP>A felhasználó panaszt tehet a Nemzeti Adatvédelmi és Információszabadság Hatóságnál is.</LegalP>
        <LegalP><LegalStrong>Nemzeti Adatvédelmi és Információszabadság Hatóság</LegalStrong></LegalP>
        <LegalUL>
          <LegalLI>Cím: 1055 Budapest, Falk Miksa utca 9-11.</LegalLI>
          <LegalLI>Postacím: 1363 Budapest, Pf. 9.</LegalLI>
          <LegalLI>Weboldal: <a href="https://www.naih.hu" target="_blank" rel="noopener noreferrer" className="text-[#5e50f7] hover:underline">www.naih.hu</a></LegalLI>
          <LegalLI>E-mail: <a href={`mailto:${NAIH_MAIL}`} className="text-[#5e50f7] hover:underline">{NAIH_MAIL}</a></LegalLI>
        </LegalUL>

        <LegalHR />
        <LegalH2>15. Cookie-k és technikai adatok</LegalH2>
        <LegalP>A mexmagic.hu weboldal használhat cookie-kat és hasonló technológiákat a weboldal működéséhez, biztonságához, analitikához vagy marketingméréshez.</LegalP>

        <LegalHR />
        <LegalH2>16. A tájékoztató módosítása</LegalH2>
        <LegalP>A Szolgáltató fenntartja a jogot, hogy jelen Adatkezelési tájékoztatót módosítsa. A mindenkor hatályos tájékoztató a mexmagic.hu weboldalon érhető el.</LegalP>

        <LegalHR />
        <LegalH2>17. Záró rendelkezések</LegalH2>
        <LegalP>A felhasználó a weboldal használatával, a webinárra történő regisztrációval vagy az e-mail kommunikációra történő feliratkozással tudomásul veszi jelen Adatkezelési tájékoztató rendelkezéseit.</LegalP>

        <LegalP style={{ marginTop: 36, color: "#8A82A8", fontSize: 13 }}>
          © {new Date().getFullYear()} MEX Magic. Minden jog fenntartva.
        </LegalP>
      </LegalContainer>
    </LegalLayout>
  );
}
